import Vue from "vue";
import VueComponents from "@tt/vue-components";
import i18n from "@/plugins/i18n";
import router from "@/router";
import store from '@/store/index'

Vue.use(VueComponents, { store, i18n, router });
